export default {
  productPrice: {
    search: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门',
      companyName: '公司名',
      orderNo: '订单号',
      orgName: '公司',
      projectCode: '项目代码',
      projectName: '项目名称',
      productCode: '原料编码',
      productName: '原料名称',
      productSpec: '规格型号',
      periodName: '账期',
      reportDateStart: '开始日期',
      reportDateEnd: '结束日期',
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '业务公司',
      businessDepartmentCode: '业务部门编码',
      businessDepartmentName: '业务部门',
    },
    column: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门',
      companyName: '公司名',
      orderNo: '订单号',
      orgName: '公司',
      projectCode: '项目代码',
      projectName: '所属项目',
      periodCode: '账期编码',
      periodName: '账期名称',
      productCode: '原料编码',
      productName: '原料名称',
      productSpec: '规格型号',
      reportDateStart: '开始日期',
      reportDateEnd: '结束日期',
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '业务公司',
      businessDepartmentCode: '业务部门编码',
      businessDepartmentName: '业务部门',
      productPrice: '当前价格',
      priceStatus: '价格状态',
    },
    label: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门',
      companyName: '公司名',
      projectCode: '项目代码',
      projectName: '项目名称',
      reportDate: '日期',
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '业务公司名称',
      businessDepartmentCode: '业务部门编码',
      businessDepartmentName: '业务部门名',
      periodName: '账期',
    },
    table: {
      sortNo: '序号',
    },
    buttons: {
      error: 'Operation failed!',
      confirm: 'Confirm',
      save: '保存',
      submit: '提交',
      upload: '上传附件',
      add: '增加',
      delete: '删除',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expandApply: '数据已存在，是否扩展申请',
      return_listPage: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enableTo_forbid: '启用只针对已禁用的状态',
      forbidTo_enable: '禁用只针对已生效的状态',
      mergeNeed_enable: '合并功能针对已生效的数据',
      saveSuccess: '保存成功',
      noProjectCode: '请选择项目名称',
      noPeriodName: '请选择账期',
      noBusinessDepartmentCode: '请选择部门',
      noReportDateStart: '请选择开始日期',
    },
    title: {
      importPeriodNameSelect: '请选择账期',
      confirmPrice: '原料价格数据 更新确认',
    },
  },
};
